import { render, staticRenderFns } from "./gridflow.vue?vue&type=template&id=df388772&scoped=true&lang=pug&"
import script from "./gridflow.vue?vue&type=script&lang=js&"
export * from "./gridflow.vue?vue&type=script&lang=js&"
import style0 from "./gridflow.vue?vue&type=style&index=0&id=df388772&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df388772",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('df388772', component.options)
    } else {
      api.reload('df388772', component.options)
    }
    module.hot.accept("./gridflow.vue?vue&type=template&id=df388772&scoped=true&lang=pug&", function () {
      api.rerender('df388772', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/box_layout/gridflow.vue"
export default component.exports